import React from 'react';
import range from 'lodash/range';
import PageItemsExpanded from './PageItemsExpanded';
import Pagination from './Pagination';
import PaginationItem from './PaginationItem';

interface PaginatorProps {
  onPageChange: (newPage: number) => void;
  numRecords: number;
  limit: number;
  offset: number;
  expandedPagesLimit?: number;
}

const Paginator = ({
  onPageChange,
  numRecords,
  limit,
  offset,
  // limit at which we swith to expanded paging view
  expandedPagesLimit = 7,
}: PaginatorProps) => {
  const numPages = Math.ceil(numRecords / limit);
  const activePage = (limit > 0 && offset / limit + 1) || 1;

  // the number of items to display for the for the expanded view (page 1, page 2, page 3, ...)
  const expandedItemsLimit = 3;

  const pageItems = numPages > 0 && range(numPages).map((n) => <PaginationItem key={n} label={(n + 1).toString()} onClick={() => onPageChange(n)} isActive={activePage === n + 1} data-cy="pagination-item" data-value={n + 1} />);

  return (
    <Pagination>
      <PaginationItem
        previous
        disabled={activePage === 1}
        onClick={() => {
          onPageChange(activePage - 2);
        }}
        data-cy="pagination-item-prev"
        data-value={activePage - 2}
      />
      {numPages >= expandedPagesLimit ? <PageItemsExpanded activePage={activePage} totalPages={numPages} limit={expandedItemsLimit} onPageChange={onPageChange} data-cy="pagination-item" data-value={activePage} /> : pageItems}
      <PaginationItem
        next
        disabled={activePage === numPages}
        onClick={() => {
          onPageChange(activePage);
        }}
        data-cy="pagination-item-next"
        data-value={activePage}
      />
    </Pagination>
  );
};

export default Paginator;
